import { isDefaultOrgOutcomeSlug } from "@/constants/orgOutcomes";

/**
 * Keeps only custom org-catalog keys for script `applicableOutcomes`.
 * Drops system static defaults (Galactus rejects them) and keys missing
 * from the catalog (eventual consistency on save).
 */
export function filterApplicableOutcomesForSave(
  keys: string[] | undefined | null,
  catalogCustomKeys: Iterable<string>
): string[] {
  if (!keys?.length) return [];

  const allowed = new Set(
    [...catalogCustomKeys].map((k) => k.trim().toLowerCase()).filter(Boolean)
  );

  const seen = new Set<string>();
  const result: string[] = [];

  for (const raw of keys) {
    const key = raw.trim();
    if (!key) continue;
    if (isDefaultOrgOutcomeSlug(key)) continue;
    const lower = key.toLowerCase();
    if (!allowed.has(lower) || seen.has(lower)) continue;
    seen.add(lower);
    result.push(key);
  }

  return result;
}
